module.exports = __webpack_public_path__ + "img/6.99fe7d67.jpg";